'use client'

import TitleBlock from '@/components/content/blocks/shared/TitleBlock'
import Section from '@/components/content/common/Section'
import RichText from '@/components/content/common/RichText'
import VideoModal from '@/components/ui/VideoModal'

import { Icon } from '@/icons/Icon'
import { extractBlogSlugUrlFromFaq } from '@/lib/formatting'
import Container from '@/components/structure/Container'
import type { Block } from '@/types/app'
import type { Page, Faq } from '@/payload-types'

type FaqTemplate = Extract<NonNullable<Page['layout']>[number], { blockType: 'faqTemplate' }>

export default function FaqBlock({ title, faqs }: FaqTemplate) {
  if (!faqs || faqs.length === 0) {
    return null
  }

  const faqObjects = faqs.filter((faq): faq is Faq => typeof faq !== 'number')

  return (
    <Container>
      <div className="mx-auto mb-14 max-w-content md:mb-32">
        <TitleBlock title={title} />

        <div className="mb-10 mt-12 flex flex-col">
          {faqObjects.map((faq, index) => {
            return (
              <Section
                key={`faq-${index}`}
                title={faq.question ?? 'Untitled'}
                isChild={true}
                icon={<Icon name="circle-question" />}
                collapsed={index > 0}
                renderCollapsedContent={true}
                copy={false}
                join={true}
                header={
                  (faq.views ?? 0) > 0 && (
                    <div className="flex shrink-0 gap-1 text-12 text-zinc-500 [&>span]:font-medium [&>span]:text-zinc-300">
                      <span>{faq.views}</span> views
                    </div>
                  )
                }
              >
                {faq.answer?.root?.children ? (
                  <RichText
                    content={faq.answer.root.children as Block[]}
                    readMore={extractBlogSlugUrlFromFaq(faq)}
                  />
                ) : (
                  <p>No answer available</p>
                )}
              </Section>
            )
          })}
        </div>

        <VideoModal className="mx-auto" />
      </div>
    </Container>
  )
}
